enum ViewMode {
	Grid = 1,
	List = 2,
};

export default ViewMode;
